import React from "react";
import PropTypes from "prop-types";
import { Button } from "@mui/material";
import appcolors from "../../constants/Colors";
import { allIcons } from "../../assets";
import { t } from "i18next";

function ExportButton({ handleClick, btnProps, styleProps, hoverProps }) {
  return (
    <Button
      onClick={handleClick}
      variant="outlined"
      disableRipple
      startIcon={
        <img src={allIcons.exportIcon} alt={"Export-icon"} width={20} />
      }
      {...btnProps}
      sx={{
        border: "none",
        borderRadius: 0,
        padding: 0,
        color: "#0000008A",
        fontWeight: 400,
        width: "auto",
        height: "auto",
        ...styleProps, // Spread additional style props
        "&:hover": {
          border: "none",
          padding: 0,
          color: "#0000008A",
          backgroundColor: "transparent",
          ...hoverProps, // Spread additional hover style props
        },
      }}
    >
      {t("export")}
    </Button>
  );
}

ExportButton.propTypes = {
  handleClick: PropTypes.func.isRequired, // handleClick is required and must be a function
  btnProps: PropTypes.object, // btnProps is optional and must be an object
  styleProps: PropTypes.object, // styleProps is optional and must be an object
  hoverProps: PropTypes.object, // hoverProps is optional and must be an object
};

ExportButton.defaultProps = {
  btnProps: {}, // Default empty object
  styleProps: {}, // Default empty object
  hoverProps: {}, // Default empty object
};

export default ExportButton;
